import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { ChevronRight } from 'lucide-react';

interface HeaderCrumbsProps {
    children: React.ReactNode;
}

const HeaderCrumbs: React.FC<HeaderCrumbsProps> = ({ children }) => {
    const [target, setTarget] = useState<HTMLElement | null>(null);

    useEffect(() => {
        setTarget(document.getElementById('breadcrumb-extra'));
    }, []);

    if (!target) return null;

    const items = React.Children.toArray(children).filter(Boolean);
    if (items.length === 0) return null;

    return createPortal(
        <>
            {items.map((child, i) => (
                <React.Fragment key={i}>
                    <ChevronRight size={14} />
                    {child}
                </React.Fragment>
            ))}
        </>,
        target
    );
};

export default HeaderCrumbs;
